module.exports = __webpack_public_path__ + "img/ayudantia_down.0728b6da.svg";